/**
 * Horizontal bars with a value column — for long labels like the age buckets.
 *
 * ⚠ A faithful port of `CS.charts.hBars` from the validated mockups. Same widths, same
 * rounding, same value column.
 */

import { formatNumber } from "@cocon-stats/shared";

import { CHART_PALETTE } from "@/components/charts/GroupedBars";

export interface HBarRow {
  label: string;
  n: number;
  tone?: string;
  /** An explicit colour wins over a palette tone. */
  color?: string;
}

export function HBars({ rows }: { rows: HBarRow[] }) {
  const max = rows.reduce((m, r) => Math.max(m, r.n), 0);

  return (
    <>
      {rows.map((row) => {
        const pct = max ? (row.n / max) * 100 : 0;
        const color = row.color ?? CHART_PALETTE[row.tone ?? "slate"] ?? CHART_PALETTE.slate;
        return (
          <div key={row.label} className="flex items-center gap-3 py-1.5">
            <span className="w-28 shrink-0 text-xs text-slate-500">{row.label}</span>
            <div className="h-5 min-w-0 flex-1 overflow-hidden rounded-full bg-slate-100">
              <div className="h-full rounded-full" style={{ width: `${pct}%`, background: color }} title={String(row.n)} />
            </div>
            <span className="num w-12 shrink-0 text-right text-sm font-bold text-slate-800">
              {formatNumber(row.n)}
            </span>
          </div>
        );
      })}
    </>
  );
}
